import { Orchestration, OrchestrationResponse } from 'api/experimentResults';
import { DropdownOption } from 'components/atoms/Dropdown/Dropdown';
import { FlowClassName, ResultsMode } from 'interfaces/experimentResults';
import { filter, flatMap, isEmpty, map, some } from 'es-toolkit/compat';
import moment from 'moment';
import { useOrchestrations } from 'utils/queryHooks/useOrchestrations';

const useOrchestrationFilter = (
  studyId: string,
  resultsMode: ResultsMode,
  flowClassNames: FlowClassName[] = [],
  onSuccessGetExperimentDefinitions?: (data: OrchestrationResponse) => void
) => {
  const getOrchestrationIdOption = (orchestration: Orchestration) => ({
    text: `${orchestration.orchestrationId}, Created at ${moment(orchestration.createdAtMinimum).format('LL')}`,
    value: orchestration.orchestrationId,
  });

  const { data: orchestrationsData, isInitialLoading: orchestrationsLoading } = useOrchestrations({
    studyId,
    resultsMode,
    onSuccess: onSuccessGetExperimentDefinitions,
  });

  const allOrchestrations: Orchestration[] = orchestrationsData?.orchestrations || [];
  const orchestrations: Orchestration[] = !isEmpty(flowClassNames)
    ? flatMap(
        flowClassNames,
        (flowClassName) =>
          map(
            filter(allOrchestrations, (orchestration) =>
              some(orchestration.slidesData, (slideData) => slideData.flowClassName === flowClassName)
            ) || [],
            (orchestration) => ({
              ...orchestration,
              slidesData: filter(orchestration.slidesData, (slideData) => slideData.flowClassName === flowClassName),
            })
          ) || []
      )
    : map(allOrchestrations, (orchestration) => ({
        ...orchestration,
        slidesData: orchestration.slidesData || [],
      }));

  const orchestrationIdOptions: DropdownOption[] = map(orchestrations, (orchestration) =>
    getOrchestrationIdOption(orchestration)
  );

  return {
    orchestrationIdOptions,
    orchestrationsLoading,
    orchestrations,
  };
};

export default useOrchestrationFilter;
